<template>
  <v-card>
    <!-- <v-card-title>User Login</v-card-title> -->
    <v-list>
      <v-list-tile avatar>
        <v-list-tile-avatar>
          <v-icon large>add</v-icon>
        </v-list-tile-avatar>

        <v-list-tile-content>
          <v-list-tile-title>Add New Coordinator</v-list-tile-title>
        </v-list-tile-content>

        <v-list-tile-action>
          <v-btn icon fav small outline @click="onCancelled">
            <v-icon>clear</v-icon>
          </v-btn>
        </v-list-tile-action>
      </v-list-tile>
    </v-list>
    <v-divider></v-divider>
    <v-card-text style="max-height: 85%">
      <v-form ref="addCoordinatorForm" v-model="valid" lazy-validation>
        <v-layout column>
          <v-flex xs12>
            <v-text-field
              outline
              label="Full Name *"
              required
              v-model="newItem.name"
              :rules="requiredRules"
            ></v-text-field>
          </v-flex>
          <v-flex xs12>
            <v-text-field
              outline
              label="Mobile *"
              v-model="newItem.mobile"
              required
              :rules="requiredRules"
            ></v-text-field>
          </v-flex>
          <v-flex xs12>
            <v-text-field
              outline
              label="Commission % *"
              type="number"
              v-model="newItem.commission_percent"
              required
              :rules="requiredRules"
            ></v-text-field>
          </v-flex>
          <v-flex xs12>
            <v-text-field outline label="Email" v-model="newItem.email"></v-text-field>
          </v-flex>
          <v-flex xs12>
            <v-text-field
              outline
              label="Address"
              v-model="newItem.address"
            ></v-text-field>
          </v-flex>
          <v-textarea v-model="newItem.notes" outline label="Notes"></v-textarea>
        </v-layout>
      </v-form>
    </v-card-text>
    <v-divider></v-divider>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn @click="onCancelled">Cancel</v-btn>
      <v-btn
        color="blue"
        @click="newItemDo"
        :disabled="!valid || actionButtonClicked"
        :loading="actionButtonClicked"
        >Add</v-btn
      >
    </v-card-actions>
  </v-card>
</template>

<script>
import { GENDERS } from "../../mdsir/const";
export default {
  data() {
    return {
      actionButtonClicked: false,
      valid: true,
      newItem: {
        name: "",
        mobile: "",
        commission_percent: "",
        email: "",
        notes: "",
        address: "",
      },
      // categories: []
    };
  },
  methods: {
    onCancelled() {
      this.$emit("cancelled");
    },
    onNewItemAdded(addedData) {
      this.$emit("added", addedData);
      this.clearForm();
      this.onCancelled();
    },
    validate() {
      if (this.$refs.addCoordinatorForm.validate()) {
        this.snackbar = true;
      }
    },
    reset() {
      this.$refs.addCoordinatorForm.reset();
    },
    resetValidation() {
      this.$refs.addCoordinatorForm.resetValidation();
    },
    clearForm() {
      this.newItem = {
        name: "",
        mobile: "",
        commission_percent: "",
        email: "",
        notes: "",
        address: "",
      };
    },
    newItemDo() {
      if (this.$refs.addCoordinatorForm.validate()) {
        this.actionButtonClicked = true;
        this.post("/coordinator", this.newItem).then((res) => {
          if (res.data.success) {
            this.onNewItemAdded(res.data.data);
          }
          this.snackbarShow(res.data);
          this.actionButtonClicked = false;
        });
      }
    },
  },
  mounted() {},
  created() {
    this.GENDERS = GENDERS;
  },
};
</script>
